import { TravellerDisability } from '@websky/graphql';
import * as React from 'react';

interface ContextProps {
	availableDisabilities: TravellerDisability[];
	passengerId: number;
}

export const DisabilitiesContext = React.createContext<ContextProps>(null);

const DisabilitiesContextProvider = DisabilitiesContext.Provider;
export default DisabilitiesContextProvider;
